import { UserScopes } from '@shared/utils/enums';

export const hasScopes = (scopes: UserScopes[], availableScopes: Set<UserScopes>, forSome = true): boolean => {
  if (!scopes || !scopes.length) {
    return true;
  }

  if (forSome) {
    return scopes.some((scope) => availableScopes.has(scope));
  } else {
    return scopes.every((scope) => availableScopes.has(scope));
  }
};
